"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecordingEllipse = void 0;
var _react = _interopRequireDefault(require("react"));
var RecordingEllipse = exports.RecordingEllipse = function RecordingEllipse() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "8",
    cy: "8",
    r: "6",
    fill: "#DE2F1B"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "8",
    cy: "8",
    r: "4.5",
    stroke: "white",
    strokeWidth: "3"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("filter", {
    id: "filter0_d",
    x: "0",
    y: "0",
    width: "16",
    height: "16",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/_react["default"].createElement("feMorphology", {
    radius: "2",
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", null), /*#__PURE__*/_react["default"].createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984314 0 0 0 0 0.917647 0 0 0 0 0.909804 0 0 0 1 0"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }))));
};